// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container passt sich dem Bildschirm an */
.dashboard-container {
  width: 90vw;
  height: 90vh;
  margin: 0;
  padding: 10px;
  overflow-y: auto;
  box-sizing: border-box;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.dashboard-group {
  width: 100%;
}

.dashboard-group-title {
  font-size: 1.2rem;
  color: white;
  margin: 0 0 10px;
  text-align: center;
  font-weight: 600;
}

/* Grid für Karten */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
}

/* Karten-Styling */
.dashboard-card {
  background-color: black; /* Grau */
  width: 100%;
  height: 100px;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid gray; 
  box-shadow: 0 2px 4px gray;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.dashboard-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.card-icon {
  font-size: 1.5rem;
  margin-bottom: 5px;
  color: #ffffff; /* Weiß */
}

.card-title {
  font-size: 0.9rem;
  margin: 0;
  font-weight: 500;
  color: #ffffff; /* Weiß */
  text-align: center;
  white-space: nowrap; /* Verhindert Zeilenumbruch */
  overflow: hidden;
  text-overflow: ellipsis; /* Kürzt Text mit "..." */
}

/* Responsive Anpassungen */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 5px;
  }

  .dashboard-group-title {
    font-size: 1rem;
    margin-bottom: 8px;
  }

  .dashboard-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 Karten nebeneinander */
    gap: 8px;
  }

  .dashboard-card {
    height: 80px;
    padding: 8px;
  }

  .card-icon {
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .card-title {
    font-size: 0.75rem;
  }
}

@media (min-width: 769px) {
  .dashboard-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/private/dashboard1.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,uBAAuB,EAAE,SAAS;EAClC,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc,EAAE,SAAS;AAC3B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAE,SAAS;EACzB,kBAAkB;EAClB,mBAAmB,EAAE,6BAA6B;EAClD,gBAAgB;EAChB,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qCAAqC,EAAE,2BAA2B;IAClE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["/* Container passt sich dem Bildschirm an */\n.dashboard-container {\n  width: 90vw;\n  height: 90vh;\n  margin: 0;\n  padding: 10px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.dashboard-content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.dashboard-group {\n  width: 100%;\n}\n\n.dashboard-group-title {\n  font-size: 1.2rem;\n  color: white;\n  margin: 0 0 10px;\n  text-align: center;\n  font-weight: 600;\n}\n\n/* Grid für Karten */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n/* Karten-Styling */\n.dashboard-card {\n  background-color: black; /* Grau */\n  width: 100%;\n  height: 100px;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid gray; \n  box-shadow: 0 2px 4px gray;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.dashboard-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.card-icon {\n  font-size: 1.5rem;\n  margin-bottom: 5px;\n  color: #ffffff; /* Weiß */\n}\n\n.card-title {\n  font-size: 0.9rem;\n  margin: 0;\n  font-weight: 500;\n  color: #ffffff; /* Weiß */\n  text-align: center;\n  white-space: nowrap; /* Verhindert Zeilenumbruch */\n  overflow: hidden;\n  text-overflow: ellipsis; /* Kürzt Text mit \"...\" */\n}\n\n/* Responsive Anpassungen */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 5px;\n  }\n\n  .dashboard-group-title {\n    font-size: 1rem;\n    margin-bottom: 8px;\n  }\n\n  .dashboard-grid {\n    grid-template-columns: repeat(2, 1fr); /* 2 Karten nebeneinander */\n    gap: 8px;\n  }\n\n  .dashboard-card {\n    height: 80px;\n    padding: 8px;\n  }\n\n  .card-icon {\n    font-size: 1.2rem;\n    margin-bottom: 4px;\n  }\n\n  .card-title {\n    font-size: 0.75rem;\n  }\n}\n\n@media (min-width: 769px) {\n  .dashboard-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
